import React, {Component}  from 'react';
import logo from './logo.svg';
import './App.css';
import Plx from 'react-plx';
import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// util components
import ScrollIntoView from "./components/utils/ScrollIntoView";

import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';

// Components
import Header from './components/general/header';
import Footer from './components/general/footer';
// Pages
import Home from './components/pages/home';
import Solutions from './components/pages/solutions';
import howitworks from './components/pages/howitworks';
import Press from './components/pages/press';
import Investors from './components/pages/investors';
import About from './components/pages/about';
import Blog from './components/pages/blog';
import Contact from './components/pages/contact';
import ArticlePage from './components/pages/blog/article_page';

// An array of parallax effects to be applied - see below for detail
const parallaxData = [
  {
    start: 0,
    end: 500,
    properties: [
      
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ],
  },
];
const parallaxData_product = [
  {
    start: 400,
    end: 500,
    properties: [
      
      {
        startValue: 1,
        endValue:.3,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: -100,
        unit: '%',
        property: 'translateY',
      },
    ],
  },
];

const textData = [
  {
    start: '.StickyText-trigger',
    duration: '30vh',
    properties: [
      {
        startValue: 0,
        endValue: -50,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  },
  {
    start: '.StickyText-trigger',
    startOffset: '60vh',
    duration: '30vh',
    properties: [
      {
        startValue: -50,
        endValue: -100,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ],
  },
];


const trackingId = "UA-159878759-1"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);

const history = createBrowserHistory();

// Initialize google analytics page view tracking
history.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});



class App extends Component {

  componentDidMount  = () => ReactGA.pageview(window.location.pathname + window.location.search);
  componentDidUpdate = () => ReactGA.pageview(window.location.pathname + window.location.search);

  
  render(){
      return (
        <Router history={history}>
    <div className="App">
    <StickyHeader
        // This is the sticky part of the header. 
        header={<Header />}
    >
        <div className="app_content_container">
        <ScrollIntoView>
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/solutions" component={Solutions} />
        <Route exact path="/howitworks" component={howitworks} />
        <Route exact path="/about" component={About} />
        <Route exact path="/press" component={Press} />
        <Route exact path="/investors" component={Investors} />
          <Route exact path="/blog" component={Blog} />
          <Route exact path={`/blog/:articleId`} component={ArticlePage}  />
        <Route exact path="/contact" component={Contact} />
      </Switch>
      </ScrollIntoView>

      </div>
      <Footer/>
      </StickyHeader>
    </div>
    </Router>
  );
}
}

export default App;
